package com.loyola.acessoescola.services

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.jsonArray
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlin.io.encoding.Base64

interface QuickAuthClient {
    suspend fun sign(onSuccessCallBack: () -> Unit, onErrorCallBack:(String?) -> Unit)
    fun getCurrentAccount(onErrorCallBack: (String?) -> Unit, onSuccessCallBack: (String?, String?) -> Unit)

    fun singout(onSuccessCallBack: () -> Unit, onErrorCallBack:(String?) -> Unit)

    fun getAppRoles(
        callBack: (List<String>) -> Unit
    ){
        getCurrentAccount({}) { _, idToken ->
            val payload = idToken?.split(".")[1] ?: throw AppRoleException("Não foi possível obter o token do usuário")

            val padded = payload.padEnd(payload.length + (4 - payload.length % 4) % 4, '=')

            val claims: JsonObject = Json.parseToJsonElement(
                Base64.UrlSafe.decode(padded).decodeToString()
            ).jsonObject

            val roles = claims["roles"]?.jsonArray?.map { it.jsonPrimitive.content }  ?: throw AppRoleException("Não foi possível obter o token do usuário")

            callBack(roles)
        }
    }

    suspend fun initialize()
}

expect class PresentationContext


expect fun getQuickAuthClient(context: PresentationContext): QuickAuthClient


class AppRoleException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)